import classNames from "classnames";
import type { PropsWithChildren } from "react";
import { getGridClass } from "./util";
import type { Column, Span } from "./types";

type GridItemProps = PropsWithChildren<{
  smColumn?: Column;
  mdColumn?: Column;
  lgColumn?: Column;
  xlColumn?: Column;
  className?: string;
  id?: string;
  row?: number;
  as?: "div" | "main" | "section" | "article" | "aside" | "nav" | "footer";
  ariaLabel?: string;
}>;

const DEFAULT_SM_COLUMN: Column = { start: 1, span: 12 };

export function GridItem({
  children,
  smColumn = DEFAULT_SM_COLUMN,
  mdColumn,
  lgColumn,
  xlColumn,
  className,
  id,
  row = 1,
  as: Component = "div",
  ariaLabel,
}: GridItemProps) {
  const cls = classNames(
    getGridClass("col-start", smColumn.start as Span),
    getGridClass("col-span", smColumn.span as Span),
    mdColumn && getGridClass("col-span", mdColumn.span as Span, "md"),
    mdColumn && getGridClass("col-start", mdColumn.start as Span, "md"),
    lgColumn && getGridClass("col-span", lgColumn.span as Span, "lg"),
    lgColumn && getGridClass("col-start", lgColumn.start as Span, "lg"),
    xlColumn && getGridClass("col-span", xlColumn.span as Span, "xl"),
    xlColumn && getGridClass("col-start", xlColumn.start as Span, "xl"),
    `[grid-row:${row}] z-10`,
    className,
  );

  return (
    <Component className={cls} id={id} aria-label={ariaLabel}>
      {children}
    </Component>
  );
}
